import React, { useState } from "react";
import { Plus } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { hasFeature } from "../lib/perms";
import { ExpenseFormDialog } from "./ExpenseFormDialog";

export const QuickExpenseFab = () => {
    const { user } = useAuth();
    const [open, setOpen] = useState(false);

    const canLaunch = hasFeature(user, "extrato") && user?.role !== "colaborador";
    if (!canLaunch) return null;

    return (
        <>
            <button
                onClick={() => setOpen(true)}
                data-testid="fab-new-expense"
                aria-label="Novo lançamento"
                title="Novo lançamento"
                className="fixed bottom-6 right-6 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-lg shadow-primary/30 transition-transform duration-200 hover:scale-105 active:scale-95"
            >
                <Plus className="h-6 w-6" />
            </button>
            <ExpenseFormDialog open={open} onOpenChange={setOpen} expense={null} />
        </>
    );
};
